'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _result2 = require('lodash/result');

var _result3 = _interopRequireDefault(_result2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _common = require('../../../common');

var _mightyFields = require('../../../../lib/mighty-fields');

var _CaseLabel = require('../../CaseLabel');

var _CaseLabel2 = _interopRequireDefault(_CaseLabel);

var _FollowUpDate = require('../../FollowUpDate');

var _FollowUpDate2 = _interopRequireDefault(_FollowUpDate);

var _FormattingUtils = require('../../../../utils/FormattingUtils');

var _FormattingUtils2 = _interopRequireDefault(_FormattingUtils);

var _utils = require('../../../../utils');

var _constants = require('../../../../constants');

var _FieldSets = require('../FieldSets');

var _CaseUpdateContact = require('../../main-contacts/CaseUpdateContact');

var _CaseUpdateContact2 = _interopRequireDefault(_CaseUpdateContact);

var _CaseUpdateModal = require('./CaseUpdateModal');

var _CaseUpdateModal2 = _interopRequireDefault(_CaseUpdateModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var EMPTY_FIELD = _constants.AppConstants.EMPTY_FIELD,
    MODEL_TYPES = _constants.AppConstants.MODEL_TYPES;
var formatParagraphs = _FormattingUtils2.default.formatParagraphs;
var CaseUpdateModule = (_dec = (0, _mobxReact.inject)('CaseStore', 'CaseUpdateStore', 'Clients', 'FunderStore', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(CaseUpdateModule, _Component);

  function CaseUpdateModule(props) {
    _classCallCheck(this, CaseUpdateModule);

    var _this = _possibleConstructorReturn(this, (CaseUpdateModule.__proto__ || Object.getPrototypeOf(CaseUpdateModule)).call(this, props));

    _initDefineProp(_this, 'isSavingLienAcknowledgment', _descriptor, _this);

    _initDefineProp(_this, 'isSavingCaseSharing', _descriptor2, _this);

    _initDefineProp(_this, 'showUpdateModal', _descriptor3, _this);

    _initDefineProp(_this, 'showTrackingDateModal', _descriptor4, _this);

    _initDefineProp(_this, 'showSettlementAmountModal', _descriptor5, _this);

    _this.caseTrackingUpdateCallbacks = {
      case_settled: _this.showSettlementAmountModal.setTrue
    };
    return _this;
  }

  _createClass(CaseUpdateModule, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.CaseStore.caseTrackingStatus.loadInitial({ id: this.props._case.id });
    }
  }, {
    key: 'updateCase',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _props, CaseStore, _case;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, CaseStore = _props.CaseStore, _case = _props._case;
                _context.next = 3;
                return CaseStore.update({ caseId: _case.id, data: data });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateCase(_x) {
        return _ref.apply(this, arguments);
      }

      return updateCase;
    }()
  }, {
    key: 'updateCaseTrackingStatus',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(caseId, data) {
        var CaseStore;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                CaseStore = this.props.CaseStore;
                _context2.next = 3;
                return CaseStore.updateCaseTrackingStatus(caseId, data);

              case 3:
                (0, _result3.default)(this.caseTrackingUpdateCallbacks, data.tracking_status, _noop3.default);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateCaseTrackingStatus(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return updateCaseTrackingStatus;
    }()
  }, {
    key: 'updateSettlementAmount',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var _props2, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, CaseStore = _props2.CaseStore;
                _context3.next = 3;
                return CaseStore.updateCaseSettlementAmount({ caseId: _case.id, data: data });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateSettlementAmount(_x4) {
        return _ref3.apply(this, arguments);
      }

      return updateSettlementAmount;
    }()
  }, {
    key: 'onFollowUpDateDelete',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.updateCase({ tracking_follow_up_date: null });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onFollowUpDateDelete() {
        return _ref4.apply(this, arguments);
      }

      return onFollowUpDateDelete;
    }()
  }, {
    key: 'onNewCaseUpdateClick',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _props3, SessionStore, CaseUpdateStore, Clients, _case, caseObject;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _props3 = this.props, SessionStore = _props3.SessionStore, CaseUpdateStore = _props3.CaseUpdateStore, Clients = _props3.Clients, _case = _props3._case;

                if (!SessionStore.isMightyFreeUser) {
                  _context5.next = 11;
                  break;
                }

                _context5.next = 4;
                return Clients.cases.retrieve(_case.id);

              case 4:
                caseObject = _context5.sent;

                CaseUpdateStore.action = 'add';
                CaseUpdateStore.caseSearchResults = [caseObject];
                CaseUpdateStore._case = caseObject;
                _reactRouter.browserHistory.push('/case-update/add');
                _context5.next = 12;
                break;

              case 11:
                this.showUpdateModal.setTrue();

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onNewCaseUpdateClick() {
        return _ref5.apply(this, arguments);
      }

      return onNewCaseUpdateClick;
    }()
  }, {
    key: 'renderFollowUpDate',
    value: function renderFollowUpDate() {
      var _case = this.props._case;


      return _react2.default.createElement(_FollowUpDate2.default, {
        followUpDate: _case.tracking_follow_up_date,
        name: 'case-tracking',
        onDeleteDate: this.onFollowUpDateDelete,
        onEditDate: this.showTrackingDateModal.setTrue
      });
    }
  }, {
    key: 'renderProgressStatus',
    value: function renderProgressStatus() {
      var tracking_status = this.props._case.tracking_summary.tracking_status;


      return _react2.default.createElement(
        'div',
        { className: 'list-tracking-status' },
        tracking_status ? _react2.default.createElement(_CaseLabel2.default, { status: tracking_status }) : EMPTY_FIELD
      );
    }
  }, {
    key: 'renderMedicalStatus',
    value: function renderMedicalStatus() {
      var medical_status = this.props._case.tracking_summary.medical_status;


      return _react2.default.createElement(
        'div',
        { className: 'list-tracking-status' },
        medical_status ? _react2.default.createElement(_CaseLabel2.default, { status: medical_status }) : EMPTY_FIELD
      );
    }
  }, {
    key: 'renderProgressAttributes',
    value: function renderProgressAttributes() {
      var tracking_attributes = this.props._case.tracking_summary.tracking_attributes;


      return _react2.default.createElement(
        'div',
        { className: 'list-tracking-status' },
        !(0, _isEmpty3.default)(tracking_attributes) ? tracking_attributes.map(function (status) {
          return _react2.default.createElement(_CaseLabel2.default, { key: status, status: status });
        }) : EMPTY_FIELD
      );
    }
  }, {
    key: 'renderUpdateModal',
    value: function renderUpdateModal() {
      var _case = this.props._case;


      if (!this.showUpdateModal.isTrue) {
        return;
      }

      return _react2.default.createElement(_CaseUpdateModal2.default, {
        _case: _case,
        onClose: this.showUpdateModal.setFalse,
        onCreate: this.updateCaseTrackingStatus
      });
    }
  }, {
    key: 'renderTrackingDateModal',
    value: function renderTrackingDateModal() {
      var _case = this.props._case,
          fieldSets = [[{
        field: 'tracking_follow_up_date',
        label: 'Tracking Follow Up',
        type: 'date'
      }]];


      if (!this.showTrackingDateModal.isTrue) {
        return;
      }

      return _react2.default.createElement(_mightyFields.FormModal, {
        fieldSets: fieldSets,
        model: _case,
        onClose: this.showTrackingDateModal.setFalse,
        onSave: this.updateCase,
        title: 'Schedule Case Tracking Update'
      });
    }
  }, {
    key: 'renderSettlementAmountModal',
    value: function renderSettlementAmountModal() {
      var _case = this.props._case;


      if (!this.showSettlementAmountModal.isTrue) {
        return;
      }

      return _react2.default.createElement(_mightyFields.FormModal, {
        cancelText: 'Skip',
        fieldSets: _FieldSets.FIELD_SETS_SETTLEMENT_AMOUNT,
        model: _case,
        onClose: this.showSettlementAmountModal.setFalse,
        onSave: this.updateSettlementAmount,
        title: 'Add settlement details'
      });
    }
  }, {
    key: 'onLienAcknowledgementChange',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _props4, _case, CaseStore, liensAcknowledged, request;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _props4 = this.props, _case = _props4._case, CaseStore = _props4.CaseStore, liensAcknowledged = !_case.liens_acknowledged;


                this.isSavingLienAcknowledgment.setTrue();

                request = CaseStore.update({
                  caseId: _case.id,
                  data: {
                    liens_acknowledged: liensAcknowledged
                  }
                });
                _context6.next = 5;
                return CaseStore.caseActivities.loadNew(MODEL_TYPES.lienAcknowledgment.key, request);

              case 5:

                this.isSavingLienAcknowledgment.setFalse();

                if (liensAcknowledged) {
                  _utils.toast.success('Success! Written confirmation of liens on file means that this is a healthier case!');
                } else {
                  _utils.toast.error('Get written confirmation that your lien is on file to make this a healthier case!');
                }

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onLienAcknowledgementChange() {
        return _ref6.apply(this, arguments);
      }

      return onLienAcknowledgementChange;
    }()
  }, {
    key: 'onCaseSharingChange',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _props5, _case, CaseStore, updatedCaseSharing;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _props5 = this.props, _case = _props5._case, CaseStore = _props5.CaseStore, updatedCaseSharing = !_case.migrate_to_registry;
                _context7.next = 3;
                return this.isSavingCaseSharing.until(CaseStore.update({
                  caseId: _case.id,
                  data: {
                    migrate_to_registry: updatedCaseSharing
                  }
                }));

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onCaseSharingChange() {
        return _ref7.apply(this, arguments);
      }

      return onCaseSharingChange;
    }()
  }, {
    key: 'renderRegistryCheckbox',
    value: function renderRegistryCheckbox() {
      var _props6 = this.props,
          _case = _props6._case,
          FunderStore = _props6.FunderStore,
          inputId = 'case-sharing',
          hideCheckbox = !(0, _get3.default)(FunderStore, 'funder.has_private_cases', false);


      if (hideCheckbox) {
        return null;
      }

      return _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement('input', {
          checked: _case.migrate_to_registry,
          disabled: this.isSavingCaseSharing.isTrue,
          id: inputId,
          name: inputId,
          onChange: this.onCaseSharingChange,
          type: 'checkbox'
        }),
        _react2.default.createElement(
          'label',
          { className: 'col-label', htmlFor: inputId },
          'Share this case with the associated law firm'
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _props7 = this.props,
          _case = _props7._case,
          CaseStore = _props7.CaseStore,
          lastTrackingUpdate = CaseStore.caseTrackingStatus.firstOrNull,
          lastTrackingUpdateBody = (0, _get3.default)(lastTrackingUpdate, 'body');


      return _react2.default.createElement(
        _common.InfoWell,
        null,
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'Tracking Follow Up'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            this.renderFollowUpDate()
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'Current Status'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            this.renderProgressStatus()
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'Current Medical Status'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            this.renderMedicalStatus()
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'Current Attributes'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            this.renderProgressAttributes()
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'Case Tracking Note'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            formatParagraphs(lastTrackingUpdateBody)
          )
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'Tracking Contact'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            _react2.default.createElement(_CaseUpdateContact2.default, { _case: _case })
          )
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement('input', {
            checked: _case.liens_acknowledged,
            disabled: this.isSavingLienAcknowledgment.isTrue,
            id: 'lien-acknowledgment',
            name: 'lien-acknowledgment',
            onChange: this.onLienAcknowledgementChange,
            type: 'checkbox'
          }),
          _react2.default.createElement(
            'label',
            { className: 'col-label', htmlFor: 'lien-acknowledgment' },
            'Our liens on this file have been confirmed in writing'
          )
        ),
        this.renderRegistryCheckbox()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Well2.default,
        { className: 'well-tracking-update' },
        _react2.default.createElement(
          'h3',
          null,
          'Case Tracking',
          !this.isLoading && _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link', className: 'btn-add', onClick: this.onNewCaseUpdateClick },
              _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
              ' New Case Update'
            )
          )
        ),
        this.isLoading ? _react2.default.createElement(_common.Loader, { className: 'page-loader' }) : this.renderBody(),
        this.renderSettlementAmountModal(),
        this.renderTrackingDateModal(),
        this.renderUpdateModal()
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this.props.CaseStore.caseTrackingStatus.loading;
    }
  }]);

  return CaseUpdateModule;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  CaseUpdateStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isSavingLienAcknowledgment', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isSavingCaseSharing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'showUpdateModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'showTrackingDateModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'showSettlementAmountModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onNewCaseUpdateClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onNewCaseUpdateClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseUpdateModule;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(EMPTY_FIELD, 'EMPTY_FIELD', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModule.js');
  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModule.js');
  reactHotLoader.register(formatParagraphs, 'formatParagraphs', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModule.js');
  reactHotLoader.register(CaseUpdateModule, 'CaseUpdateModule', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModule.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModule.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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